"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("@powerednow/complexData/entity");
const date_1 = require("@powerednow/shared/modules/utilities/date");
const constants_1 = require("@powerednow/shared/constants");
let AddressEntity = class AddressEntity extends entity_1.EntityWithCompanyId {
};
__decorate([
    (0, entity_1.field)({ type: 'int', primaryKey: true })
], AddressEntity.prototype, "id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', codeName: 'isDefault', allowNull: true })
], AddressEntity.prototype, "isdefault", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean' })
], AddressEntity.prototype, "invoice", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'string',
        convert: function convert(value) {
            if (constants_1.COUNTRY.CONVERT[value]) {
                return constants_1.COUNTRY.CONVERT[value];
            }
            return value;
        },
    })
], AddressEntity.prototype, "country", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', allowNull: true, fulltextSearchField: true })
], AddressEntity.prototype, "state", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', allowNull: true, fulltextSearchField: true })
], AddressEntity.prototype, "city", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', allowNull: true, fulltextSearchField: true })
], AddressEntity.prototype, "county", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', allowNull: true, fulltextSearchField: true })
], AddressEntity.prototype, "address1", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', allowNull: true, fulltextSearchField: true })
], AddressEntity.prototype, "address2", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'string', codeName: 'postCode', allowNull: true, fulltextSearchField: true,
    })
], AddressEntity.prototype, "postcode", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], AddressEntity.prototype, "customer_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', primaryKey: true, serverOnly: true })
], AddressEntity.prototype, "company_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', dbType: 'date', defaultValue: date_1.getNow })
], AddressEntity.prototype, "dt_created", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'boolean', serverOnly: true, codeName: 'isDeleted', defaultValue: false,
    })
], AddressEntity.prototype, "isdeleted", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'string', dbType: 'date', serverOnly: true, defaultValue: null, allowNull: true,
    })
], AddressEntity.prototype, "dt_deleted", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', fulltextSearchField: true })
], AddressEntity.prototype, "name", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', defaultValue: true })
], AddressEntity.prototype, "is_registered", void 0);
__decorate([
    (0, entity_1.field)({ type: 'boolean', defaultValue: false })
], AddressEntity.prototype, "is_invoice", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'int', minAppVersion: '8.5.7', serverOnly: true, defaultValue: null, allowNull: true,
    })
], AddressEntity.prototype, "expert_trades_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', defaultValue: null, allowNull: true })
], AddressEntity.prototype, "what_three_words", void 0);
AddressEntity = __decorate([
    entity_1.EntityDecorator
], AddressEntity);
exports.default = AddressEntity;
//# sourceMappingURL=../../../../src/models/address/entity.js.map